module.exports = __webpack_public_path__ + "static/img/Patrick_Cripps_desktop.f7f70c6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Patrick_Cripps_desktop.jpg
// module id = 8hPK
// module chunks = 0